module.exports = __webpack_public_path__ + "media/images/lb/772-346fca7e316d830ea137875cee7fb69f.svg";